/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function PictouWestByElectionInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Pictou West - May 21, 2024 By-elections"
              description={
                <>
                <h4>
                  Summary Results and Statistics
                </h4>
                < u><a href="/files/PictouWestByElection/PictouWestByElection_Report.pdf">Pictou West By-election Report</a></u>
                <br/>
                <br/>
                <h4>
                  Pictou West By-election Financial Report
                </h4>
                < u><a href="/files/PictouWestByElection/PictouWestByElection_FinanceReport_Final.pdf">Pictou West By-election Financial Report</a></u>
                <br/>
                <br/>
                  <p><strong>Pictou West By-election Expenses</strong></p>
                  <ul style={{ paddingLeft: "40px" }}>
                  <li><a href="/files/PictouWestByElection/2024_ED43_C%20Brett_Green_RevisedExpenses%20-%20Final%20after%202-6.pdf">Clare Brett (Green) Expenses</a> (PDF)</li>
                  <li><a href="/files/PictouWestByElection/2024_ED43_W-Elliott_LIB_RevisedExpenses%20-%20Final%20after%202-6.pdf">Mary Wooldridge Elliott (Liberal) Expenses</a> (PDF)</li>
                  <li><a href="/files/PictouWestByElection/2024_ED43_MelindaMacKenzie_NSNDP_RevisedExpenses.pdf">Melinda MacKenzie (NSNDP) Expenses</a> (PDF)</li>
                  <li><a href="/files/PictouWestByElection/2024_ED43_M%20MacLeod_PC_RevisedExpenses%20-%20Final%20after%202-6.pdf">Marco MacLeod (PC) Expenses</a> (PDF)</li>
                  </ul>
                  <br/>
                  
                  <p><strong>Pictou West By-election Candidate Disclosure</strong></p>
                  <ul style={{ paddingLeft: "40px" }}>
                  <li><a href={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(window.location.origin + '/files/PictouWestByElection/2024_ED43_ClareBrett_Green_Disclosure.xlsx')}&wdOrigin=BROWSELINK`}>Clare Brett (Green) Disclosure</a> (Excel)</li>
                  <li><a href={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(window.location.origin + '/files/PictouWestByElection/2024_ED43_MaryWooldridge-Elliott_Liberal_Disclosure.xlsx')}&wdOrigin=BROWSELINK`}>Mary Wooldridge Elliott (Liberal) Disclosure</a> (Excel)</li>
                  <li><a href={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(window.location.origin + '/files/PictouWestByElection/2024_ED43_MelindaMacKenzie_NSNDP_Disclosure.xlsx')}&wdOrigin=BROWSELINK`}>Melinda MacKenzie (NSNDP) Disclosure</a> (Excel)</li>
                  <li><a href={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(window.location.origin + '/files/PictouWestByElection/2024_ED43_MarcoMacLeod_PC_Disclosure.xlsx')}&wdOrigin=BROWSELINK`}>Marco MacLeod (PC) Disclosure</a> (Excel)</li>
                  </ul>
                  <br/>
                  
                  <p><strong>Pictou West By-election Registered Party Expenses</strong></p>
                  <ul style={{ paddingLeft: "40px" }}>
                  <li><a href="/files/PictouWestByElection/Green%20Party.pdf">Green Party of Nova Scotia</a> (PDF)</li>
                  <li><a href="/files/PictouWestByElection/Nova%20Scotia%20PC%20Party.pdf">Progressive Conservative Association of Nova Scotia</a> (PDF)</li>
                  <li><a href="/files/PictouWestByElection/LiberalParty_ElectionExpenses_2024.pdf">Nova Scotia Liberal Party</a> (PDF)</li>
                  <li><a href="/files/PictouWestByElection/NSNDP_ElectionsExpenses_2024.pdf">Nova Scotia New Democratic Party</a> (PDF)</li>
                  
                  </ul><br/>
                  <h3>Report of the Chief Electoral Officer on the Proceedings of the Pictou West By-election</h3>
                  <br/>
                  <p>The Chief Electoral Officer (CEO) of Nova Scotia, Dorothy Rice, has released the report on the proceedings of the Pictou West by-election held on May 21, 2024. The report was submitted to the House of Assembly in accordance with Section 163 of the <a href="http://nslegislature.ca/legc/statutes/elections.pdf"><em>Elections Act</em></a>.</p>
                  <br/>
                  <p>The report provides a summary of the by-election results and detailed statistics on the vote. Financial information on election expenses, candidate reimbursement, election administration costs, and financial statistics will be released at a later date.</p>
                  <br/>
                  <p>Please follow this link to view the <a href="/files/PictouWestByElection/PictouWestByElection_Report.pdf">Pictou West by-election report</a>.</p>
                  <br/>
                  <h3>Final Spending Limits for the Pictou West By-election</h3>
                  <br/>
                  <p>Candidate spending limits in an electoral district are adjusted if there is an increase in the number of electors on the Final List of Electors. The final list of electors is complete for the Pictou West by-election.</p>
                  <br/>
                  <p>The following spending limits and reimbursement amounts are determined according to the Elections Act (updated to include CPI adjustments):</p>
                  <br/>
                  <p><strong>Number of Electors</strong>: 12,113 (as of June 7, 2024)</p>
                  <p><strong>Candidate Spending Limit*</strong>: $84,160.53</p>
                  <p><strong>Maximum Candidate Reimbursement</strong>: $23,526.18</p>
                  <p><strong>Registered Party Spending Limit</strong>: $7,773.25</p>
                  <p><strong>Third Party Maximum Spending in this by-election</strong>: $2,716.40</p>
                  <br/>
                  <p><em>*The candidate spending limit for the Pictou West by-election has been adjusted based on the number of electors on the Final List of Electors as of June 7, 2024.</em></p>
                  <br/>
                  <h3>Financial Reporting Deadlines for the Pictou West By-election</h3>
                  <br/>
                  <p>Elections Nova Scotia reminds candidates, registered political parties, and third-party advertisers from the Pictou West by-election held on Tuesday, May 21, 2024, that financial reports are due in the weeks and months ahead. All reports must be sent to the Chief Electoral Officer.</p>
                  <br/>
                  <p>Candidate tax receipts are due 30 days after election day, <strong>June 20, 2024</strong>.</p>
                  <p>Candidate financial reports, including audit reports, are due (80 days after writ) on <strong>August 19, 2024</strong>. It is also important to remember that there are fines of $50 per day for late candidate reports.</p>
                  <p>Registered party financial reports are due (120 days after Writ) on <strong>September 28, 2024</strong>.</p>
                  <p>Third-party election advertising reports are due on <strong>September 21, 2024</strong>.</p>

                  <br />
                  <br />
                  ENS is an independent non-partisan agency that reports to the members of the House of Assembly through the Speaker. Its mandate is to deliver provincial elections impartially and professionally.
 

                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default PictouWestByElectionInformation;
